<div class="mt-2 flex h-full w-full flex-col">
  <form
    class="flex items-center gap-6"
    [formGroup]="appointmentsFilterForm"
  >
    @if (withSearch()) {
      <mat-form-field class="w-1/3">
        <mat-icon matIconPrefix>search</mat-icon>
        <mat-label>{{ "appointments.label.search" | translate }}</mat-label>
        <input
          matInput
          [formControl]="filtersFc.search"
        />
        @if (filtersFc.search.value) {
          <button
            matSuffix
            mat-icon-button
            type="button"
            aria-label="Clear"
            (click)="clearSearch()"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }

    <div class="mb-4 flex gap-6">
      <!-- Type filter -->
      <div>
        <button
          class="btn btn-filter flex w-fit flex-1 items-center"
          type="button"
          [matMenuTriggerFor]="appointmentTypes"
        >
          <label class="flex items-center gap-2 px-1">
            <span class="font-bold">
              {{ "Тип:&nbsp;" }}
            </span>
            <span>{{ (filtersFc.type.value === typeFilter.All ? "context.filters." : "medicalServices.appointment.") + filtersFc.type.value | translate }}</span>
            @if (filtersFc.type.value !== typeFilter.All) {
              <button
                class="text-xs text-primary-500"
                type="button"
                aria-label="Clear"
                (click)="clearFilter('type', $event)"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </label>
          <img
            alt="Filter"
            width="16"
            height="16"
            [ngSrc]="'/assets/icons/ic_arrow_down.svg'"
          />
        </button>
        <mat-menu
          #appointmentTypes="matMenu"
          xPosition="before"
        >
          <button
            mat-menu-item
            (click)="setTypeFilter(typeFilter.All)"
          >
            {{ "context.filters.All" | translate }}
          </button>
          @for (type of visitTypes | keyvalue; track type) {
            <mat-divider></mat-divider>
            <button
              mat-menu-item
              (click)="setTypeFilter(type.value)"
            >
              {{ "medicalServices.appointment." + type.value | translate }}
            </button>
          }
        </mat-menu>
      </div>

      <!-- Status filter -->
      <div>
        <button
          class="btn btn-filter flex w-fit flex-1 items-center"
          type="button"
          [matMenuTriggerFor]="appointmentStatuses"
        >
          <label class="flex items-center gap-2 px-1">
            <span class="font-bold">
              {{ "Статус:&nbsp;" }}
            </span>
            <span>{{ "context.filters." + filtersFc.status.value | translate }}</span>
            @if (filtersFc.status.value !== statusFilter.All) {
              <button
                class="text-xs text-primary-500"
                type="button"
                aria-label="Clear"
                (click)="clearFilter('status', $event)"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </label>
          <img
            alt="Filter"
            width="16"
            height="16"
            [ngSrc]="'/assets/icons/ic_arrow_down.svg'"
          />
        </button>
        <mat-menu
          #appointmentStatuses="matMenu"
          xPosition="before"
        >
          <button
            mat-menu-item
            (click)="setStatusFilter(statusFilter.All)"
          >
            {{ "context.filters.All" | translate }}
          </button>
          <mat-divider></mat-divider>
          <button
            mat-menu-item
            (click)="setStatusFilter(statusFilter.ToDo)"
          >
            {{ "context.filters.ToDo" | translate }}
          </button>
          <mat-divider></mat-divider>
          <button
            mat-menu-item
            (click)="setStatusFilter(statusFilter.Done)"
          >
            {{ "context.filters.Done" | translate }}
          </button>
          <mat-divider></mat-divider>
          <button
            mat-menu-item
            (click)="setStatusFilter(statusFilter.Rejected)"
          >
            {{ "context.filters.Rejected" | translate }}
          </button>
        </mat-menu>
      </div>

      <!-- Period filter -->
      <shared-period-filter [formControl]="filtersFc.period"></shared-period-filter>
    </div>
  </form>
  @if (loading()) {
    <div class="flex h-0 min-h-0 flex-1 items-center justify-center">
      <shared-loader></shared-loader>
    </div>
  } @else {
    <div
      class="relative h-0 min-h-0 flex-1 overflow-y-auto"
      sharedInfiniteScroll
      [scrollLoading]="appointmentsFetching()"
      [hasNextPage]="hasNextPage()"
      (fetchNextPage)="fetchNextPage()"
    >
      <hm-appointments-table
        [withName]="withPatientName()"
        [appointments]="appointments()"
        (listUpdated)="updateAppointmentsList()"
        (sortChanged)="onSortChanged($event)"
      ></hm-appointments-table>
    </div>
    @if (appointments().length && appointmentsFetching()) {
      <div class="absolute bottom-0 z-10 flex w-full items-center justify-center">
        <shared-spin-loading [size]="24"></shared-spin-loading>
      </div>
    }
  }
</div>
